import React, { useState, useEffect, useRef } from 'react';
import { Box, Container, CssBaseline, Stack, Typography, Button, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { useNavigate } from 'react-router';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';
import Loader from '../../global/Loader';
import DialogMsg from '../../global/DialogMsg';
import { useTranslation } from 'react-i18next';

const { GetConsents, GetConsentFile } = onBoardingEkycServices;

const TermUse = () => {
  const navigate = useNavigate();
  const frameRef = useRef();
  const { t } = useTranslation();
  // const [ifCheck, setIfCheck] = useState(false);
  // const [ifCheck, setIfCheck] = useState(true); // for now bypass checkbox of acknowledge
  const [ifCheck, setIfCheck] = useState(false); // logical
  const [CheckError, setCheckError] = useState(false);
  const [openloader, setOpenloader] = useState(false);
  const [openDialogeMsg, setOpenDialogeMsg] = useState(false);
  const [dialogMsg, setDialogMsg] = useState('');
  const [htmlDataForIframe, setHtmlDataForIframe] = useState('Loading....');

  console.log('CheckErrorCheckError', ifCheck);
  console.log('CheckErrorCheckError', CheckError);
  // console.log('htmlDataForIframe', htmlDataForIframe);

  const localStorageLangKey = localStorage.getItem('i18nextLng');
  const selectedLang = localStorageLangKey ? localStorageLangKey : '';

  // GetConsentsApi API
  const GetConsentsApi = async () => {
    try {
      setOpenloader(true);
      const GetConsentsResponse = await GetConsents();
      if (GetConsentsResponse.status === 'Success') {
        if (GetConsentsResponse.data.length > 0) {
          // no need of sorting
          // const sortConsentSeq = GetConsentsResponse.data.sort(
          //   (a, b) => a.consentSeq - b.consentSeq
          // ); // sorting
          // const sequence1 = sortConsentSeq.filter(
          //   (ByConsentSeq) => ByConsentSeq?.consentSeq === 1 && ByConsentSeq?.isShow === true
          // )[0].url;
          const sequence1 = GetConsentsResponse.data.filter(
            (ByConsentSeq) => ByConsentSeq?.consentSeq === 1 && ByConsentSeq?.isShow === true
          )[0].url;

          if (sequence1 !== null && sequence1 !== '' && sequence1 !== undefined) {
            GetConsentFileApi(sequence1);
          } else {
            // navigate('/in/terms-of-service');
          }
        } else {
          setOpenDialogeMsg(true);
          setDialogMsg('Data not found');
        }
      } else if (GetConsentsResponse.status === 'Failure') {
        // navigate('/in/terms-of-service'); hide because we are going to hardcode below terms and condition
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };
  // GetConsents file API
  const GetConsentFileApi = async (consentsUrl) => {
    try {
      setOpenloader(true);
      const credential = { userId: 1, fileName: consentsUrl };
      const GetConsentsResponse = await GetConsentFile(credential);
      setHtmlDataForIframe(GetConsentsResponse);
    } catch (error) {
      console.log(error);
    } finally {
      setOpenloader(false);
    }
  };

  // Error Dialog close handler
  const closeDialogMsgHandler = (e) => {
    setOpenDialogeMsg(false);
  };

  useEffect(() => {
    GetConsentsApi();
  }, []);

  return (
    <>
      <Loader openloader={openloader} />
      <PageHeading pageTitle={t('Terms of use')} />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Box className="termServiceBox hScrollbar" mb={2}>
          {/* <Typography variant="subtitle1">1.Definition</Typography> */}
          {/* hide because we are going to hardcode below terms and condition */}
          {/* <List className="ListOuter">
            <ListItem disablePadding className="listItem">
              <Box
                className="iframeStyle quill"
                ref={frameRef}
                onScroll={(e) => {
                  if (e.target.scrollTop > 30) {
                    // setDisableButton(false);
                  }
                }}
              >
                <div
                  className="kl-editor"
                  dangerouslySetInnerHTML={{ __html: htmlDataForIframe }}
                />
              </Box>
            </ListItem>
          </List> */}

          {/* Hard code without dyanmic for the time being */}
          <Typography variant="body2" mb={2}>
            {selectedLang === 'hi'
              ? `अधोहस्ताक्षरी ग्राहक इसके द्वारा फिनको बैंक को स्वीकार करता है और स्पष्ट रूप से सहमति देता है
              के एकमात्र उद्देश्य के लिए उनकी व्यक्तिगत जानकारी एकत्र करना, संसाधित करना और संग्रहीत करना
              लागू कानूनों के अनुसार अपने ग्राहक को जानें (केवाईसी) प्रक्रियाओं का संचालन करना,
              विनियम, और बैंकिंग उद्योग मानक।`
              : selectedLang === 'gj'
              ? `નીચે સહી કરેલ ગ્રાહક આથી FINCO બેંકને સ્વીકારે છે અને સ્પષ્ટપણે સંમતિ આપે છે
              ના એકમાત્ર હેતુ માટે તેમની વ્યક્તિગત માહિતી એકત્રિત કરવી, પ્રક્રિયા કરવી અને સંગ્રહિત કરવી
              લાગુ પડતા કાયદાઓ અનુસાર તમારા ગ્રાહકને જાણો (KYC) પ્રક્રિયાઓ હાથ ધરવી,
              નિયમો અને બેંકિંગ ઉદ્યોગના ધોરણો.`
              : `The undersigned customer hereby acknowledges and expressly consents to FINCO Bank
            collecting, processing, and storing their personal information for the sole purpose of
            conducting Know Your Customer (KYC) procedures in accordance with applicable laws,
            regulations, and banking industry standards.`}
          </Typography>

          <Typography variant="body2" mb={2}>
            {selectedLang === 'hi'
              ? `इस सहमति में व्यक्तिगत का संग्रह और सत्यापन शामिल है, लेकिन यह इन्हीं तक सीमित नहीं है
              विवरण, दस्तावेज़, चित्र, बायोमेट्रिक डेटा, और आवश्यक समझी जाने वाली कोई भी अन्य जानकारी
              केवाईसी प्रक्रिया के लिए. ग्राहक समझता है कि इस डेटा प्रोसेसिंग का उद्देश्य क्या है
              कानूनी आवश्यकताओं को पूरा करना, बैंकिंग की सुरक्षा और अखंडता बनाए रखना है
              सेवाएँ, और धोखाधड़ी वाली गतिविधियों को रोकें।`
              : selectedLang === 'gj'
              ? `આ સંમતિમાં વ્યક્તિગતના સંગ્રહ અને ચકાસણીનો સમાવેશ થાય છે પરંતુ તે તેના સુધી મર્યાદિત નથી
              વિગતો, દસ્તાવેજો, છબીઓ, બાયોમેટ્રિક ડેટા અને અન્ય કોઈપણ માહિતી જરૂરી માનવામાં આવે છે
              કેવાયસી પ્રક્રિયા માટે. ગ્રાહક સમજે છે કે આ ડેટા પ્રોસેસિંગનો હેતુ છે
              કાનૂની જરૂરિયાતોને પૂર્ણ કરવા, બેંકિંગની સુરક્ષા અને અખંડિતતા જાળવવા માટે છે
              સેવાઓ, અને કપટપૂર્ણ પ્રવૃત્તિઓ અટકાવે છે.`
              : `This consent includes but is not limited to the collection and verification of personal
              details, documents, images, biometric data, and any other information deemed necessary
              for the KYC process. The customer understands that the purpose of this data processing
              is to fullfill legal requirements, maintain the security and integrity of banking
              services, and prevent fraudulent activities.`}
          </Typography>

          <Typography variant="body2" mb={2}>
            {selectedLang === 'hi'
              ? `ग्राहक आगे स्वीकार करता है कि यह सहमति इलेक्ट्रॉनिक के उपयोग तक फैली हुई है
              इसका मतलब है, सत्यापन उद्देश्यों के लिए वीडियो नो योर कस्टमर (वीकेवाईसी) सत्र सहित।
              फिनको बैंक ग्राहक को आश्वस्त करता है कि एकत्रित की गई सभी जानकारी का ध्यान रखा जाएगा
              अत्यंत गोपनीयता और सुरक्षित रूप से संग्रहित।`
              : selectedLang === 'gj'
              ? `ગ્રાહક વધુમાં સ્વીકારે છે કે આ સંમતિ ઇલેક્ટ્રોનિકના ઉપયોગ સુધી વિસ્તરે છે
              મતલબ, ચકાસણી હેતુઓ માટે વિડિયો તમારા ગ્રાહકને જાણો (VKYC) સત્રો સહિત.
              ફિન્કો બેંક ગ્રાહકને ખાતરી આપે છે કે તમામ એકત્રિત માહિતી સાથે વ્યવહાર કરવામાં આવશે
              અત્યંત ગોપનીયતા અને સુરક્ષિત રીતે સંગ્રહિત.`
              : `The customer further acknowledges that this consent extends to the use of electronic
              means, including video Know Your Customer (VKYC) sessions, for verification purposes.
              FINCO Bank assures the customer that all collected information will be treated with the
              utmost confidentiality and stored securely.`}
          </Typography>

          <Typography variant="body2">
            {selectedLang === 'hi'
              ? `यह सहमति स्वतंत्र रूप से और स्वेच्छा से दी जाती है, और ग्राहक के पास इसका अधिकार बरकरार रहता है
              इसे किसी भी समय वापस लें. हालाँकि, सहमति वापस लेने से बैंक पर असर पड़ सकता है
              कुछ सेवाएँ प्रदान करने की क्षमता। ग्राहक यह भी स्वीकार करता है कि बैंक ऐसा कर सकता है
              केवाईसी में शामिल तृतीय-पक्ष सेवा प्रदाताओं के साथ आवश्यक जानकारी साझा करें
              प्रक्रिया, डेटा सुरक्षा के साथ समान स्तर की गोपनीयता और अनुपालन सुनिश्चित करना
              विनियम.`
              : selectedLang === 'gj'
              ? `આ સંમતિ મુક્તપણે અને સ્વૈચ્છિક રીતે આપવામાં આવે છે, અને ગ્રાહક તેનો અધિકાર જાળવી રાખે છે
              તેને કોઈપણ સમયે પાછી ખેંચી લો. જો કે, સંમતિ પાછી ખેંચી લેવાથી બેંકને અસર થઈ શકે છે
              ચોક્કસ સેવાઓ પ્રદાન કરવાની ક્ષમતા. ગ્રાહક પણ સ્વીકારે છે કે બેંક મે
              કેવાયસીમાં સામેલ થર્ડ-પાર્ટી સર્વિસ પ્રોવાઇડર્સ સાથે જરૂરી માહિતી શેર કરો
              પ્રક્રિયા, સમાન સ્તરની ગોપનીયતા અને ડેટા સુરક્ષાનું પાલન સુનિશ્ચિત કરે છે
              નિયમો`
              : `This consent is granted freely and voluntarily, and the customer retains the right to
              withdraw it at any time. However, the withdrawal of consent may impact the bank's
              ability to provide certain services. The customer also acknowledges that the bank may
              share necessary information with third-party service providers involved in the KYC
              process, ensuring the same level of confidentiality and compliance with data protection
              regulations.`}
          </Typography>
          {/* Hard code without dyanmic for the time being */}
        </Box>
        <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={6} md={6}>
            <FormControlLabel
              className="checkbox"
              control={
                <Checkbox
                  size="small"
                  sx={{ color: '#3C3C4B', '&.Mui-checked': { color: '#03989a' } }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setIfCheck(true);
                      setCheckError(false);
                    } else {
                      setIfCheck(false);
                    }
                  }}
                />
              }
              label={<Typography variant="body2">{t('Acknowledge and accept')}</Typography>}
            />
            {CheckError && (
              <Typography variant="body2" sx={{ color: 'red', fontSize: '13px' }}>
                {t('Please choose to acknowledge and accept the terms')}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={6} textAlign="right">
            <Button
              className="mainBtn"
              onClick={(e) => {
                if (ifCheck === true) {
                  // navigate('/in/terms-of-service');
                  navigate('/in/document-choose');
                } else {
                  setCheckError(true);
                  return '';
                }
              }}
            >
              {t('Agree')}
            </Button>
          </Grid>
        </Grid>

        <DialogMsg
          openDialogeMsg={openDialogeMsg}
          dialogMsg={dialogMsg}
          dialogTitle="Alert"
          buttonText="Close"
          closeDialogMsgHandler={closeDialogMsgHandler}
        />
      </Container>
    </>
  );
};

export default TermUse;
